import { ok } from '@shared/utils';
import type { Result, AppError, AsyncResult } from '@shared/utils';
import { PackageBootstrap } from '@shared/core';
import type { PackageResourceConfig, PackagePostBootstrapTask } from '@shared/core';
import type { LoggerEnvironmentConfig } from '../../config/interfaces/LoggerEnvironmentConfig';
import { Logger } from '../../classes/Logger';
import type { LoggerRuntimeKind } from '../types/LoggerRuntimeKind';
import { LoggerGlobalErrorHandlersPostBootstrapTask } from './LoggerGlobalErrorHandlersPostBootstrapTask';

/**
 * @group Logger Bootstrap
 * @summary
 * <blockquote>Bootstrap definition for `@shared/logger` — configures the Logger runtime
 * and registers global error handler post-bootstrap tasks.</blockquote>
 *
 * @example
 * ```typescript
 * import { LoggerPackageBootstrap } from '@shared/logger';
 *
 * const loggerEntry = {
 *   definition: new LoggerPackageBootstrap('server'),
 *   config: loggerResourceConfig,
 * };
 * ```
 */
export class LoggerPackageBootstrap extends PackageBootstrap<LoggerEnvironmentConfig> {
  readonly packageId = '@shared/logger';

  constructor(public readonly runtimeKind: LoggerRuntimeKind) {
    super();
  }

  async configureRuntime(
    config: PackageResourceConfig<LoggerEnvironmentConfig>
  ): AsyncResult<void, AppError> {
    Logger.configureRuntime(config);
    return ok(undefined);
  }

  getPostBootstrapTasks(): Result<ReadonlyArray<PackagePostBootstrapTask>, AppError> {
    return ok([new LoggerGlobalErrorHandlersPostBootstrapTask(this.runtimeKind)]);
  }
}
